export default __webpack_public_path__ + "static/media/IMG4145.217891f8.jpg";